import {NgModule } from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppComponent} from './app.component';
import {CoreModule} from "./core/core.module";
import {AuthModule} from "./auth/auth.module";
import {MainModule} from "./main/main.module";

import {AuthenticationService} from "./shared/services/authentication.service";

@NgModule({
    imports: [
        BrowserModule,
        CoreModule,
        AuthModule,
        MainModule
    ],
    declarations: [
        AppComponent
    ],
    exports: [
        AuthModule,
        MainModule
    ],

    providers: [
        AuthenticationService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}


// WEBPACK FOOTER //
// /code/frontend/src/app/app.module.ts